import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { DialogInfoVariant } from '@shared/ui';

@Component({
  selector: 'ui-dialog-info',
  standalone: true,
  imports: [],
  templateUrl: './dialog-info.component.html',
  styleUrl: './dialog-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogInfoComponent {
  public readonly label = input.required();
  public readonly variant = input<DialogInfoVariant>('danger');

  protected readonly cssClass = computed(
    () => `dialog__info--${this.variant()}`,
  );
}
